import React from 'react';
import './KpiCard.scss';

export interface Kpi {
  label: string;
  value: string;
  unit: string;
  sub: string;
}

const KpiCard = ({ label, value, unit, sub }: Kpi) => (
  <div className="KpiCard">
    <span className="KpiCard__label">{label}</span>
    <span className="KpiCard__value">
      <span>{value}</span>
      <span>{unit}</span>
    </span>
    <span className="KpiCard__sub">{sub}</span>
  </div>
);

export default KpiCard;
